import { Field } from '@sitecore-jss/sitecore-jss-nextjs';
import { sanitize } from 'isomorphic-dompurify';

export type GenericBentoGridTextProps = {
  id?: string;
  isHeading: Field<boolean>;
  text: Field<string>;
};

const GenericBentoGridTextFieldComponent = ({ isHeading, text }: GenericBentoGridTextProps) => {
  return (
    <>
      {isHeading?.value ? (
        <h3
          className="heading-3 md:heading-4"
          dangerouslySetInnerHTML={{ __html: sanitize(text?.value) }}
        />
      ) : (
        <p className="paragraph" dangerouslySetInnerHTML={{ __html: sanitize(text?.value) }} />
      )}
    </>
  );
};

export default GenericBentoGridTextFieldComponent;
